<template>
  <div class="project pa-3">
    <div v-if="hasAccessToProjectManagement && storeReady">
      <project-dashboard v-if="showProjectDashboard" />

      <project-profile v-if="showProjectProfile" />

      <project-modal />
    </div>

    <div v-else-if="!hasAccessToProjectManagement">
      <access-denied-card
        title="Access Denied"
        message="You don't have permission to view projects."
        details="Project access is restricted to authorized team members. If you believe you should have access to this feature, please contact your administrator."
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { makeProject } from '@/internal/store/utils/project'
import ensureModuleRegistered from '@/utils/store'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')

export default {
  name: 'Project',

  components: {
    AccessDeniedCard: () => import('../components/AccessDeniedCard'),
    ProjectDashboard: () => import('../components/Projects.vue'),
    ProjectModal: () => import('../components/ProjectModal'),
    ProjectProfile: () => import('../components/Project.vue'),
  },

  data() {
    return {
      storeReady: false,
    }
  },

  computed: {
    ...mapAuthGetters([
      'hasAccessToProjectManagement',
    ]),

    isProjectModalVisible() {
      return this.$store.state.internal
        ? this.$store.state.internal.isProjectModalVisible
        : false
    },

    showProjectDashboard() {
      const { reportId } = this.$route.params

      return !reportId || reportId.length === 0 || reportId === 'dashboard'
    },

    showProjectProfile() {
      const { reportId } = this.$route.params
      return reportId && reportId.length > 0 && reportId !== 'dashboard'
    },
  },

  watch: {
    /**
     * When navigating back to the dashboard view from the profile,
     * reload the projects data to ensure the list is populated.
     */
    showProjectDashboard: {
      immediate: false,
      handler(isDashboard, wasDashboard) {
        // Only reload when transitioning to dashboard (from profile)
        if (isDashboard && !wasDashboard) {
          this.$store.dispatch('internal/setProjectView')
        }
      },
    },
  },

  async created() {
    // Ensure internal store module is registered before any child dispatches internal/* actions
    await ensureModuleRegistered(this.$store, 'internal')
    this.storeReady = true

    // Self-managed view: load own data
    await this.$store.dispatch('tools/setView', 'projects')
  },

  methods: {
    async showFormProject() {
      const action = 'create'
      const formData = makeProject({})

      const result = await this.$store.dispatch('internal/showFormProject', { action, formData })

      this.$log.info('Show Project Form', result)

      return result
    },
  },
}
</script>
